import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

function toggleNavigationOpen() {
  return (dispatch: Dispatch) => {
    dispatch(actions.toggleOpen())
  }
}

function toggleNavigationItem(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.toggleItem(id))
  }
}

export const useNavigationActions = () => {
  return {
    toggleNavigationOpen: useThunkActions(toggleNavigationOpen),
    toggleNavigationItem: useThunkActions(toggleNavigationItem)
  }
}
